import { Component, OnInit } from '@angular/core';
import { FormlyType } from '../ga-formly.service';
import { ExtraFieldType } from '../extra-field-type';
import { GaFormlyUtil } from '../ga-formly.util';

@Component({
  selector: 'formly-field-dateinput',
  template: `
	  <date-picker 
			[control]="formControl"
			(pickedDate)="onPickedDate($event)" 
			[attr.date-label]="to.label" 
			[attr.date-key]="key" 
			[attr.date-translate]="to.translate" 
			[ngClass]="classNames"
			[focus]="to.inputFocus"
      [minDate]="to.minDate"
      [maxDate]="to.maxDate"
		>
		</date-picker>
		
		<input class="d-none" [formControl]="formControl" [formlyAttributes]="field">
	`
})
export class FormlyFieldDateinputComponent extends ExtraFieldType implements OnInit {

  constructor(
    private formlyUtil: GaFormlyUtil
  ) {
    super();
  }

  public ngOnInit():void {
    this.classNames = this.formlyUtil.createClassNames(FormlyType.DATE_INPUT, <string>this.key, this.to.label);

    // register listener
    this.listen();
  }

  public onPickedDate(date:Date):void {
    this.formControl.patchValue(date);

    this.formControl.markAsTouched();
    this.formControl.markAsDirty();
  }
}